"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

/**
 * Link to a section, like "/#faq". On the page that has the section, it scrolls
 * there and sets a clean URL itself, instead of leaving the hash to the browser.
 * From other pages it navigates normally.
 */
export function SectionLink({
  href,
  onClick,
  ...props
}: Omit<React.ComponentProps<typeof Link>, "href"> & { href: string }) {
  const pathname = usePathname();

  return (
    <Link
      href={href}
      {...props}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const [path, id] = href.split("#");
        if (!id || (path && path !== pathname)) return;
        const section = document.getElementById(id);
        if (!section) return;
        e.preventDefault();
        window.history.pushState(null, "", `${pathname}#${id}`);
        // Wait a frame so layout changes from the click (like the mobile menu
        // closing) land first. Smooth unless reduced motion, via globals.css.
        requestAnimationFrame(() => section.scrollIntoView());
      }}
    />
  );
}
